import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// @ts-nocheck
import context from "./plugin/context";
var autoClick = function autoClick(Tracert, cb) {
  // 注册事件到Tracert
  Tracert.set(_objectSpread({}, context));
  // 绑定点击事件
  Tracert.spmClickEvent('', Tracert.eventType);
  // 修改属性里面如果有点击事件，则重新绑定点击事件
  Tracert.before('set', function (opt) {
    var options = opt;
    options.eventType = options.eventType || options.eventName;
    if (options.eventType) {
      Tracert.spmClickEvent(Tracert.eventType, options.eventType);
    }
  });
  cb();
  return Tracert;
};
export default autoClick;